import { defineComponent as _defineComponent } from 'vue'
import ItemListaDetalhes from '@/components/ItemListaDetalhes.vue'
import Irmao from '@/../common/types/Irmao'


export default /*#__PURE__*/_defineComponent({
  __name: 'AbaPessoalDoIrmao',
  props: {
    irmao: null
  },
  setup(__props: any) {



return { __sfc: true,ItemListaDetalhes }
}

})